import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import api from '../../services/api'
import { createLogger } from '../../utils/logger'

const logger = createLogger('StrategySelector')

const STRATEGIES = [
  {
    value: 'STANDARD_ADAPTIVE',
    label: 'Standard Adaptive',
    description: 'Classic SAT-style adaptive difficulty'
  },
  {
    value: 'PROGRESSIVE_ENGAGEMENT',
    label: 'Progressive Engagement (CDS)',
    description: 'Composite Difficulty Score — nuanced difficulty progression across 10 levels'
  },
  {
    value: 'KNOWLEDGE_GRAPH',
    label: 'Knowledge Graph Dependent',
    description: 'Graph-aware question selection that targets knowledge gaps'
  }
]

export default function StrategySelector({ currentStrategy, onUpdate }) {
  const [selected, setSelected] = useState(currentStrategy || 'STANDARD_ADAPTIVE')
  const [saving, setSaving] = useState(false)

  // Sync local state when the store updates (e.g., after checkAuth re-fetches user)
  useEffect(() => {
    setSelected(currentStrategy || 'STANDARD_ADAPTIVE')
  }, [currentStrategy])

  const handleSave = async () => {
    setSaving(true)
    try {
      await api.put('/users/me/preferences', { challengeStrategy: selected })
      onUpdate?.(selected)
    } catch (err) {
      logger.error('Failed to save strategy:', err)
      toast.error('Failed to save strategy')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-gray-700">Question Generation Strategy</h3>
      <div className="space-y-2">
        {STRATEGIES.map((strategy) => (
          <label
            key={strategy.value}
            className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
              selected === strategy.value
                ? 'border-primary-400 bg-primary-50'
                : 'border-gray-200 hover:bg-gray-50'
            }`}
          >
            <input
              type="radio"
              name="challengeStrategy"
              value={strategy.value}
              checked={selected === strategy.value}
              onChange={() => setSelected(strategy.value)}
              className="mt-0.5"
            />
            <div>
              <div className="text-sm font-medium">{strategy.label}</div>
              <div className="text-xs text-gray-500">{strategy.description}</div>
            </div>
          </label>
        ))}
      </div>
      {selected !== currentStrategy && (
        <button
          onClick={handleSave}
          disabled={saving}
          className="px-4 py-2 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save Strategy'}
        </button>
      )}
    </div>
  )
}
